/**
 * NEW badge on Searchanise Instant Search product tiles.
 *
 * Custom HTML (focus / extra / nothing-found) cannot edit per-product cards.
 * This script watches .snize-product tiles (#snize-ac-product-{id}) and
 * overlays the same bt-new-badge.png used on collection cards when
 * created_at / published_at is within 14 days.
 *
 * Also draws the TOP 熱賣 rank badge (bt-top-badge, from window.BT_TOP20 set in
 * layout/theme.liquid) and shows it instead of NEW for top-20 products.
 *
 * Upload as Assets → bt-searchanise-new.js
 * theme.liquid before </body>:
 *
 *   <script>
 *     window.__BT_BADGE_ASSETS__ = window.__BT_BADGE_ASSETS__ || {
 *       newImg: {{ 'bt-new-badge.png' | asset_url | json }}
 *     };
 *   </script>
 *   <script src="{{ 'bt-searchanise-new.js' | asset_url }}" defer></script>
 */
(function () {
  var NEW_IMG =
    (window.__BT_BADGE_ASSETS__ && window.__BT_BADGE_ASSETS__.newImg) ||
    "/cdn/shop/t/9/assets/bt-new-badge.png";
  var DAY = 86400;
  var NEW_DAYS = 14;
  var byId = null;
  var byHandle = null;
  var loading = null;
  var watched = new WeakSet();
  var BT_TOP_CLASS = "bt-top-badge--snize";

  function log() {
    if (window.__BT_BADGES_DEBUG__) {
      console.log.apply(console, ["[bt-snize-new]"].concat([].slice.call(arguments)));
    }
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function productIdFromTile(tile) {
    if (!tile || !tile.id) return null;
    var m = String(tile.id).match(/snize-(?:ac-)?product-(\d+)/i);
    if (m) return m[1];
    m = String(tile.id).match(/(\d{8,})/);
    return m ? m[1] : null;
  }

  function coverHost(tile) {
    var img =
      tile.querySelector("img.snize-item-image") || tile.querySelector("img");
    var host =
      tile.querySelector(".snize-thumbnail") ||
      tile.querySelector(".snize-image-wrapper") ||
      (img && img.parentElement) ||
      tile.querySelector("a.snize-view-link") ||
      tile;
    if (host) {
      var pos = window.getComputedStyle(host).position;
      if (pos === "static") host.style.position = "relative";
      host.style.overflow = "visible";
    }
    return host;
  }

  function ensureNew(host) {
    if (!host || host.querySelector(".bt-new-badge")) return;
    var span = document.createElement("span");
    span.className = "bt-new-badge bt-new-badge--snize";
    span.setAttribute("aria-label", "新登場");
    span.style.cssText =
      "position:absolute;top:4px;right:4px;z-index:20;display:block;width:56px;max-width:38%;line-height:0;pointer-events:none;";
    span.innerHTML =
      '<img src="' +
      NEW_IMG +
      '" alt="NEW 新登場" width="118" height="64" style="display:block;width:100%;height:auto;" loading="lazy">';
    host.appendChild(span);
  }


  // ---- 熱賣 HOT SALE badge (Top1–30 via window.BT_TOP20; art = BT_HOT_SALE_IMG) ----
  // Restored 2026-10-29 fire badge D — single sticker for all ranks (was Instant Search TOP hide)
  function topRankById(id) {
    var map = window.BT_TOP20;
    if (!map || id == null) return 0;
    var m = String(id).match(/(\d+)\s*$/); // numeric id or gid://shopify/Product/123
    if (!m) return 0;
    var r = parseInt(map[m[1]], 10);
    return r >= 1 && r <= 30 ? r : 0;
  }

  function removeNew(host, scope) {
    [host, scope].forEach(function (n) {
      if (!n || !n.querySelectorAll) return;
      n.querySelectorAll(".bt-new-badge").forEach(function (e) {
        e.remove();
      });
    });
  }

  function hotSaleSrc() {
    return (
      window.BT_HOT_SALE_IMG ||
      (window.__BT_BADGE_ASSETS__ && window.__BT_BADGE_ASSETS__.hotSaleImg) ||
      ""
    );
  }

  function ensureTop(host, rank, cssText) {
    if (!host || !rank) return;
    var src = hotSaleSrc();
    if (!src) return;
    var old = host.querySelector(".bt-top-badge");
    if (old) {
      if (old.getAttribute("data-rank") === String(rank) && old.getAttribute("data-hot") === "1") return;
      old.remove();
    }
    var span = document.createElement("span");
    span.className = "bt-top-badge " + BT_TOP_CLASS;
    span.setAttribute("data-rank", String(rank));
    span.setAttribute("data-hot", "1");
    span.setAttribute("aria-label", "熱賣 HOT SALE");
    span.style.cssText = cssText;
    span.innerHTML =
      '<img src="' + src + '" alt="熱賣 HOT SALE" width="60" height="60" style="display:block;width:100%;height:auto;" loading="lazy">';
    host.appendChild(span);
  }

  // Relative size vs cover host (16.8% = 21×0.8, boss −20% 2026-10-29). Same ratio every tile size.
  // Inline styles because Instant Search tiles may not inherit theme base.css sizing.
  function topCss() {
    return "position:absolute;top:4px;right:4px;z-index:21;display:block;width:16.8%;max-width:16.8%;line-height:0;pointer-events:none;";
  }

  function isNew(product) {
    if (!product) return false;
    var raw = product.created_at || product.published_at;
    if (!raw) return false;
    return Date.now() / 1000 - new Date(raw).getTime() / 1000 < NEW_DAYS * DAY;
  }

  function loadCatalog() {
    if (byId) return Promise.resolve();
    if (loading) return loading;
    loading = (async function () {
      byId = Object.create(null);
      byHandle = Object.create(null);
      for (var page = 1; page <= 12; page++) {
        var res = await fetch("/products.json?limit=250&page=" + page, {
          credentials: "same-origin",
        });
        if (!res.ok) break;
        var list = ((await res.json()) || {}).products || [];
        if (!list.length) break;
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          byId[String(p.id)] = p;
          byHandle[p.handle] = p;
        }
        if (list.length < 250) break;
      }
      log("catalog", Object.keys(byId).length);
    })().catch(function (e) {
      log("catalog err", e);
      byId = byId || Object.create(null);
      byHandle = byHandle || Object.create(null);
    });
    return loading;
  }

  function resolveProduct(tile) {
    var id = productIdFromTile(tile);
    if (id && byId[id]) return byId[id];

    var link =
      tile.querySelector("a.snize-view-link") ||
      tile.querySelector('a[href*="/products/"]');
    var handle = link ? handleFromUrl(link.getAttribute("href")) : null;
    if (handle && byHandle[handle]) return byHandle[handle];

    return null;
  }

  function fetchByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (byHandle && byHandle[handle]) return Promise.resolve(byHandle[handle]);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function enhance(tile) {
    if (!(tile instanceof Element)) return;
    if (!tile.classList.contains("snize-product")) return;
    if (tile.getAttribute("data-bt-new") === "1") return;
    if (tile.getAttribute("data-bt-new") === "pending") return;

    // TOP 20: the tile id / data-original-product-id is the numeric product id,
    // so no network wait is needed. TOP replaces NEW.
    var quickRank = topRankById(
      productIdFromTile(tile) || tile.getAttribute("data-original-product-id")
    );
    if (quickRank) {
      var h = coverHost(tile);
      removeNew(h, tile);
      ensureTop(h, quickRank, topCss());
      tile.setAttribute("data-bt-new", "1");
      log("top", tile.id, quickRank);
      return;
    }

    tile.setAttribute("data-bt-new", "pending");
    loadCatalog().then(function () {
      var product = resolveProduct(tile);
      var link =
        tile.querySelector("a.snize-view-link") ||
        tile.querySelector('a[href*="/products/"]');
      var handle = link ? handleFromUrl(link.getAttribute("href")) : null;

      var done = function (p) {
        var rank = p ? topRankById(p.id) : 0;
        log("product", p && p.handle, "id", productIdFromTile(tile), "top", rank, "new?", isNew(p));
        if (rank) {
          var h = coverHost(tile);
          removeNew(h, tile);
          ensureTop(h, rank, topCss());
        } else if (isNew(p)) {
          ensureNew(coverHost(tile));
        }
        tile.setAttribute("data-bt-new", "1");
      };

      if (product) return done(product);
      if (handle) return fetchByHandle(handle).then(done);

      log("unresolved", tile.id, handle);
      tile.removeAttribute("data-bt-new");
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll
      ? scope.querySelectorAll(".snize-product, [id^='snize-ac-product-']")
      : [];
    // if root itself is a product tile
    if (root && root.nodeType === 1 && root.classList && root.classList.contains("snize-product")) {
      enhance(root);
    }
    list.forEach(enhance);
    log("scan", list.length);
    return list.length;
  }

  function watchRoot(root) {
    if (!root || watched.has(root)) return;
    watched.add(root);
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (
            n.matches &&
            (n.matches(".snize-product") || n.matches("[id^='snize-ac-product-']"))
          ) {
            enhance(n);
          } else if (n.querySelectorAll) {
            scan(n);
          }
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function bindSearchaniseEvents() {
    function onUpdated() {
      scan(document);
    }

    // Native CustomEvents (some themes / integrations)
    document.addEventListener("Searchanise.AutocompleteUpdated", onUpdated);
    document.addEventListener("Searchanise.ResultsUpdated", onUpdated);

    // Official jQuery events on Searchanise.$
    function bindJq() {
      var $ = window.Searchanise && window.Searchanise.$;
      if (!$ || !$.fn) return false;
      $(document)
        .off(".btSnizeNew")
        .on("Searchanise.AutocompleteUpdated.btSnizeNew", onUpdated)
        .on("Searchanise.ResultsUpdated.btSnizeNew", onUpdated);
      log("jq events bound");
      return true;
    }

    if (!bindJq()) {
      document.addEventListener("Searchanise.Loaded", function () {
        bindJq();
        scan(document);
      });
    }
  }

  function start() {
    window.__BT_BADGES_DEBUG__ = window.__BT_BADGES_DEBUG__ || false;
    loadCatalog();
    watchRoot(document.documentElement);
    bindSearchaniseEvents();
    scan(document);
    [600, 1500, 3000, 6000].forEach(function (ms) {
      setTimeout(function () {
        scan(document);
      }, ms);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
